export default __webpack_public_path__ + "static/media/back3.319ad943.jpg";